import { useQuery } from '@tanstack/react-query';
import { useGraphqlClient, clientGetScoreAssessmentsOnDemandForFirm } from '../graphql';
import { saodKeys } from './queryKeys';

export const useScoreAssessmentsOnDemandForFirm = (firmID: string | undefined | null, includeEstateStatus = false) => {
  const gqlClient = useGraphqlClient();

  const scoreAssessmentsOnDemandForFirmQuery = useQuery<
    Awaited<ReturnType<typeof clientGetScoreAssessmentsOnDemandForFirm>>
  >({
    enabled: !!firmID,
    queryKey: saodKeys.forFirm(firmID, includeEstateStatus),
    queryFn: () => {
      if (!firmID) throw new Error('A firm ID is required to load score assessments');
      return clientGetScoreAssessmentsOnDemandForFirm(gqlClient, { firmID, includeEstateStatus });
    },
  });

  return {
    scoreAssessmentsOnDemandForFirmQuery,
    scoreAssessmentsOnDemandForFirm: scoreAssessmentsOnDemandForFirmQuery.data?.items || [],
  };
};
